// 类型定义
export interface DashboardData {
  userActivity: {
    dailyActive: number;
    monthlyActive: number;
    dailyTrend: Array<{ date: string; value: number }>;
    monthlyTrend: Array<{ month: string; value: number }>;
  };
  customerStats: {
    total: number;
    monthlyNew: number;
    weeklyNew: number;
    dailyNew: number;
    regionDistribution: Array<{ region: string; count: number }>;
    ageDistribution: Array<{ ageRange: string; count: number }>;
    totalTrend: Array<{ date: string; value: number }>;
    monthlyNewTrend: Array<{ date: string; value: number }>;
    weeklyNewTrend: Array<{ date: string; value: number }>;
    dailyNewTrend: Array<{ date: string; value: number }>;
  };
  dailyMetrics: {
    revenue: number;
    serviceCount: number;
    reportCount: number;
    trend: Array<{
      date: string;
      revenue: number;
      serviceCount: number;
      reportCount: number;
    }>;
  };
  monthlyMetrics: {
    revenue: number;
    serviceCount: number;
    reportCount: number;
    trend: Array<{
      month: string;
      revenue: number;
      serviceCount: number;
      reportCount: number;
    }>;
  };
}

export interface StaffMember {
  id: string;
  avatar: string;
  name: string;
  gender: "男" | "女";
  age: number;
  phone: string;
  address: string;
  idCard: string;
  idCardImage: string;
  healthCertImage: string;
  joinDate: string;
  serviceCount: number;
  customerCount: number;
  rating: string;
  status: "待审核" | "已审核" | "已离职";
}

// Customer interface moved to customerOrderApi.ts

export interface ServiceEvaluation {
  id: string;
  serviceNumber: string;
  serviceType:
    | "随访个性化"
    | "医院陪诊"
    | "搬运重物"
    | "水电维修"
    | "生活用品代买"
    | "代收代拿快递";
  staffId: string;
  staffName: string;
  staffPhone: string;
  customerId: string;
  customerName: string;
  customerPhone: string;
  evaluatorName: string;
  evaluatorPhone: string;
  serviceStartTime: string;
  serviceEndTime: string;
  actualDuration: number;
  standardDuration: number;
  meetsStandard: boolean;
  overallRating: number;
  attitudeRating: number;
  resultRating: number;
  feedback: string;
  feedbackImages: string[];
  evaluationDate: string;
}

// 运营看板数据
export const dashboardData: DashboardData = {
  // 用户活跃度数据
  userActivity: {
    dailyActive: 1285,
    monthlyActive: 8964,
    dailyTrend: [
      { date: "2024-01-01", value: 1200 },
      { date: "2024-01-02", value: 1180 },
      { date: "2024-01-03", value: 1220 },
      { date: "2024-01-04", value: 1285 },
      { date: "2024-01-05", value: 1350 },
      { date: "2024-01-06", value: 1400 },
      { date: "2024-01-07", value: 1380 },
    ],
    monthlyTrend: [
      { month: "2023-07", value: 7800 },
      { month: "2023-08", value: 8200 },
      { month: "2023-09", value: 8500 },
      { month: "2023-10", value: 8800 },
      { month: "2023-11", value: 8600 },
      { month: "2023-12", value: 8964 },
      { month: "2024-01", value: 9200 },
    ],
  },

  // 客户统计数据
  customerStats: {
    total: 3456,
    monthlyNew: 128,
    weeklyNew: 35,
    dailyNew: 8,
    regionDistribution: [
      { region: "北京", count: 856 },
      { region: "上海", count: 724 },
      { region: "广州", count: 612 },
      { region: "深圳", count: 598 },
      { region: "杭州", count: 456 },
      { region: "其他", count: 210 },
    ],
    ageDistribution: [
      { ageRange: "60-65岁", count: 892 },
      { ageRange: "66-70岁", count: 1024 },
      { ageRange: "71-75岁", count: 756 },
      { ageRange: "76-80岁", count: 512 },
      { ageRange: "80岁以上", count: 272 },
    ],
    // 客户数量趋势数据
    totalTrend: [
      { date: "2023-07", value: 3156 },
      { date: "2023-08", value: 3198 },
      { date: "2023-09", value: 3245 },
      { date: "2023-10", value: 3298 },
      { date: "2023-11", value: 3356 },
      { date: "2023-12", value: 3420 },
      { date: "2024-01", value: 3456 },
    ],
    monthlyNewTrend: [
      { date: "2023-07", value: 98 },
      { date: "2023-08", value: 115 },
      { date: "2023-09", value: 106 },
      { date: "2023-10", value: 132 },
      { date: "2023-11", value: 125 },
      { date: "2023-12", value: 118 },
      { date: "2024-01", value: 128 },
    ],
    weeklyNewTrend: [
      { date: "第1周", value: 28 },
      { date: "第2周", value: 32 },
      { date: "第3周", value: 29 },
      { date: "第4周", value: 35 },
      { date: "第5周", value: 31 },
      { date: "第6周", value: 38 },
      { date: "第7周", value: 35 },
    ],
    dailyNewTrend: [
      { date: "01-01", value: 6 },
      { date: "01-02", value: 4 },
      { date: "01-03", value: 9 },
      { date: "01-04", value: 7 },
      { date: "01-05", value: 8 },
      { date: "01-06", value: 5 },
      { date: "01-07", value: 8 },
    ],
  },

  // 日运营指标
  dailyMetrics: {
    revenue: 125600,
    serviceCount: 342,
    reportCount: 298,
    trend: [
      {
        date: "2024-01-01",
        revenue: 118000,
        serviceCount: 320,
        reportCount: 285,
      },
      {
        date: "2024-01-02",
        revenue: 122000,
        serviceCount: 335,
        reportCount: 290,
      },
      {
        date: "2024-01-03",
        revenue: 119500,
        serviceCount: 328,
        reportCount: 275,
      },
      {
        date: "2024-01-04",
        revenue: 125600,
        serviceCount: 342,
        reportCount: 298,
      },
      {
        date: "2024-01-05",
        revenue: 128000,
        serviceCount: 355,
        reportCount: 310,
      },
      {
        date: "2024-01-06",
        revenue: 132000,
        serviceCount: 365,
        reportCount: 320,
      },
      {
        date: "2024-01-07",
        revenue: 130000,
        serviceCount: 358,
        reportCount: 315,
      },
    ],
  },

  // 月运营指标
  monthlyMetrics: {
    revenue: 3456000,
    serviceCount: 9876,
    reportCount: 8654,
    trend: [
      {
        month: "2023-07",
        revenue: 3200000,
        serviceCount: 9200,
        reportCount: 8100,
      },
      {
        month: "2023-08",
        revenue: 3350000,
        serviceCount: 9400,
        reportCount: 8300,
      },
      {
        month: "2023-09",
        revenue: 3280000,
        serviceCount: 9100,
        reportCount: 8000,
      },
      {
        month: "2023-10",
        revenue: 3420000,
        serviceCount: 9600,
        reportCount: 8400,
      },
      {
        month: "2023-11",
        revenue: 3380000,
        serviceCount: 9500,
        reportCount: 8350,
      },
      {
        month: "2023-12",
        revenue: 3456000,
        serviceCount: 9876,
        reportCount: 8654,
      },
      {
        month: "2024-01",
        revenue: 3580000,
        serviceCount: 10200,
        reportCount: 8900,
      },
    ],
  },
};

// 服务人员数据
export const staffData: StaffMember[] = Array.from(
  { length: 156 },
  (_, index) => ({
    id: `STAFF${String(index + 1).padStart(4, "0")}`,
    avatar: `https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`,
    name: [
      "张小芳",
      "李明华",
      "王丽娟",
      "陈建国",
      "刘晓霞",
      "赵国强",
      "孙美丽",
      "周志华",
    ][index % 8],
    gender: index % 2 === 0 ? "女" : "男",
    age: 25 + (index % 15),
    phone: `138${String(index).padStart(8, "0")}`,
    address:
      [
        "北京市朝阳区",
        "上海市浦东新区",
        "广州市天河区",
        "深圳市南山区",
        "杭州市西湖区",
      ][index % 5] + `某某街道${index + 1}号`,
    idCard: `110101199${String(80 + (index % 20)).padStart(2, "0")}0101${String(
      index
    ).padStart(4, "0")}`,
    idCardImage: `https://via.placeholder.com/300x200?text=身份证${index + 1}`,
    healthCertImage: `https://via.placeholder.com/300x200?text=健康证${
      index + 1
    }`,
    joinDate: new Date(2023, index % 12, (index % 28) + 1)
      .toISOString()
      .split("T")[0],
    serviceCount: 50 + (index % 200),
    customerCount: (index % 8) + 1,
    rating: (4.0 + (index % 10) / 10).toFixed(1),
    status: ["待审核", "已审核", "已离职"][index % 3] as
      | "待审核"
      | "已审核"
      | "已离职",
  })
);

// 服务评价数据
export const serviceEvaluationData: ServiceEvaluation[] = Array.from(
  { length: 267 },
  (_, index) => {
    const serviceTypes: Array<
      | "随访个性化"
      | "医院陪诊"
      | "搬运重物"
      | "水电维修"
      | "生活用品代买"
      | "代收代拿快递"
    > = [
      "随访个性化",
      "医院陪诊",
      "搬运重物",
      "水电维修",
      "生活用品代买",
      "代收代拿快递",
    ];

    // 简化的客户数据，仅用于服务评价数据生成
    const customerNames = [
      "张伟",
      "李娜",
      "王强",
      "刘芳",
      "陈军",
      "杨丽",
      "黄勇",
      "赵敏",
      "孙涛",
      "周琳",
    ];
    const elderNames = [
      "张老太",
      "李大爷",
      "王奶奶",
      "陈爷爷",
      "刘姥姥",
      "赵大妈",
      "孙老头",
      "周老太",
      "马爷爷",
      "朱奶奶",
    ];

    const staff = staffData[index % staffData.length];
    const serviceType = serviceTypes[index % serviceTypes.length];

    const serviceStartTime = new Date(
      2024,
      0,
      1 + (index % 90),
      8 + (index % 10),
      index % 60
    );
    const standardDuration =
      serviceType === "随访个性化"
        ? 60
        : serviceType === "医院陪诊"
        ? 180
        : serviceType === "搬运重物"
        ? 90
        : serviceType === "水电维修"
        ? 120
        : serviceType === "生活用品代买"
        ? 45
        : 30; // 代收代拿快递

    const actualDuration = standardDuration + (index % 60) - 30; // 实际时长在标准时长上下浮动
    const serviceEndTime = new Date(
      serviceStartTime.getTime() + actualDuration * 60000
    );

    const overallRating = Math.ceil(Math.random() * 5);
    const attitudeRating = Math.ceil(Math.random() * 5);
    const resultRating = Math.ceil(Math.random() * 5);

    const feedbackTexts = [
      "服务人员态度很好，工作认真负责，非常满意！",
      "按时到达，服务质量不错，但是速度可以再快一些。",
      "非常专业，解决了我们的问题，值得推荐。",
      "服务人员很细心，耐心解答问题，服务态度很好，工作效率也很高，整体非常满意。",
      "工作完成得很好，但是来得有点晚。",
      "服务质量一般，还有改进空间。",
      "非常满意这次服务，服务人员专业素质很高，工作认真细致，态度友善，完全超出了我的期望。希望以后能继续保持这样的服务水准。",
      "还可以，基本满足需求。",
    ];

    const feedback = feedbackTexts[index % feedbackTexts.length];

    // 生成评价图片（模拟）
    const imageCount = index % 4; // 0-3张图片
    const feedbackImages = Array.from(
      { length: imageCount },
      (_, imgIndex) =>
        `https://via.placeholder.com/400x300?text=评价图片${imgIndex + 1}`
    );

    return {
      id: `EVAL${String(index + 1).padStart(4, "0")}`,
      serviceNumber: `SRV-${new Date().getFullYear()}-${String(
        index + 1
      ).padStart(6, "0")}`,
      serviceType: serviceType,
      staffId: staff.id,
      staffName: staff.name,
      staffPhone: staff.phone,
      customerId: `CUSTOMER${String(index + 1).padStart(4, "0")}`,
      customerName: elderNames[index % elderNames.length],
      customerPhone: `137${String(index).padStart(8, "0")}`,
      evaluatorName: customerNames[index % customerNames.length], // 评价人是子女
      evaluatorPhone: `139${String(index).padStart(8, "0")}`,
      serviceStartTime: serviceStartTime.toISOString(),
      serviceEndTime: serviceEndTime.toISOString(),
      actualDuration: Math.max(actualDuration, 1), // 确保时长为正数
      standardDuration: standardDuration,
      meetsStandard: actualDuration >= standardDuration,
      overallRating: overallRating,
      attitudeRating: attitudeRating,
      resultRating: resultRating,
      feedback: feedback,
      feedbackImages: feedbackImages,
      evaluationDate: new Date(
        serviceEndTime.getTime() + (1 + (index % 72)) * 3600000
      ).toISOString(), // 服务结束后1-72小时内评价
    };
  }
);
